export const fetchSharedContent = (request, { signal, code }) =>
  request({
    method: 'get',
    pathname: `/api/share/${encodeURIComponent(code)}`,
    signal,
    notShowErrorMessage: true,
  });
